import React, { useEffect, useState } from "react";
import Spinner from "../../Shared/Feature/LoadingSpinner/Spinner";
import axios from "axios";
import ipconfig from "../../Core/ipconfig";
import Textinput from "../../Shared/Widgets/TextInput";
import {
  Box,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Menu,
  Paper,
  Divider,
  Grid,
  Card,
  CardContent,
  useTheme,
  Chip,
  IconButton,
} from "@mui/material";
import BadgeIcon from "@mui/icons-material/Badge";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import EmailIcon from "@mui/icons-material/Email";
import CallIcon from "@mui/icons-material/Call";
import ComputerIcon from "@mui/icons-material/Computer";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import CalculateIcon from "@mui/icons-material/Calculate";
import HandshakeIcon from "@mui/icons-material/Handshake";
import StoreIcon from "@mui/icons-material/Store";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";

import { formatPhoneNumber } from "../../Core/util/formatPhone";

export default function Userdetail({ data, updatedetailes, readOnly }: any) {
  const theme = useTheme();
  const [formData, setFormData] = useState<any>(null);
  const [connData, setConnData] = useState([]);
  const [partnersData, setPartnersData] = useState([]);
  const [partnerId, setPartnerId]: any = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePartnerSelect = (selectedId: string) => {
    const selectedItem: any = partnersData.find(
      (item: any) => item._id === selectedId
    );
    setFilterValue(selectedId);
    setPartnerId(selectedItem?._id);
    setAnchorEl(null);
  };

  const handleUserData = async () => {
    setFormData(null);
    try {
      if (data?._id) {
        const response = await axios.get(
          `${ipconfig}/fetchuserbyid?userId=${data?._id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.status === 200) {
          const uData = response?.data?.data;
          setFormData(uData);
          setConnData(response?.data?.connectorDetails || []);
          if (uData?.partnerDetails?._id) {
            setPartnerId(uData.partnerDetails._id);
          } else if (uData?.referedBy) {
            setPartnerId(uData.referedBy);
          }
        }
      }
    } catch (error) {
      console.log(error, "Error ----->");
    }
  };

  const getAllPartners = async () => {
    try {
      const response = await axios.get(
        `${ipconfig}/fetch/partner?partnerType=approved`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.status === 200) {
        setPartnersData(response?.data?.data || []);
      }
    } catch (error: any) {
      console.log(error, "Error while getting partners");
    }
  };

  const handleAsignPartner = async () => {
    try {
      const response = await axios.put(
        `${ipconfig}/user/refer`,
        {
          userId: data?._id,
          partnerId: partnerId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.status === 200) {
        toast.success("Partner assigned successfully.", {
          position: "top-center",
          autoClose: 1000,
        });
        handleUserData();
      }
    } catch (error: any) {
      console.log(error, "Error while assigning partner");
      toast.error(error?.response?.data?.message || "Error assigning partner", {
        position: "top-center",
        autoClose: 1000,
      });
    }
  };

  useEffect(() => {
    handleUserData();
  }, [data?._id]);

  useEffect(() => {
    getAllPartners();
  }, []);

  const getPartnerName = (id: string) => {
    if (formData?.partnerDetails?._id === id && formData?.partnerDetails?.contactPersonName) {
      return `${formData.partnerDetails.contactPersonName} (${formData.partnerDetails.partnerCode})`;
    }
    const partner: any = partnersData.find((p: any) => p._id === id);
    return partner ? `${partner.contactPersonName} (${partner.partnerCode})` : "Select Partner";
  };

  if (!formData) {
    return <Spinner height="100%" />;
  }

  const fields = [
    { label: "Name", name: "name", icon: <BadgeIcon />, isCopyable: true },
    { label: "Email", name: "email", icon: <EmailIcon />, isCopyable: true },
    {
      label: "Mobile no",
      name: "phoneNumber",
      customValue: formatPhoneNumber(formData?.phoneNumber, formData?.countryCode),
      icon: <CallIcon />,
      isCopyable: true,
    },
    {
      label: "Connector last active",
      name: "connectorLastActive",
      defaultValue: "N/A",
      icon: <ComputerIcon />,
      isDate: false,
    },
    {
      label: "Mobile last active",
      name: "mobileLastActive",
      defaultValue: "N/A",
      icon: <SmartphoneIcon />,
      isDate: false,
    },
    {
      label: "Tally Connected",
      name: "isTallyConnected",
      defaultValue: "No",
      icon: <CalculateIcon />,
      isBoolean: true,
    },
    {
      label: "Joined since",
      name: "createdAt",
      defaultValue: "N/A",
      icon: <HandshakeIcon />,
      isDate: true,
    },
    ...(data?.isOwner
      ? [
        {
          label: "Referral Code",
          name: "referalCode",
          customValue: formData?.referalCode || formData?.referalcode || formData?.partnerDetails?.partnerCode || "N/A",
          defaultValue: "N/A",
          icon: <HandshakeIcon />,
          isCopyable: true,
        },
        {
          label: "Referred Partner",
          name: "partnerName",
          customValue: formData?.partnerDetails
            ? `${formData.partnerDetails.contactPersonName} (${formData.partnerDetails.partnerCode})`
            : "None",
          defaultValue: "None",
          icon: <HandshakeIcon />,
          isCopyable: false,
        },
      ]
      : []),
  ];

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "24px" }}>
      {/* Header and Partner Assignment */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: "text.primary" }}>
              {formData.name}
            </Typography>
            <IconButton
              size="small"
              onClick={() => {
                navigator.clipboard.writeText(formData.name);
                toast.success("Name copied to clipboard!", { position: "top-center", autoClose: 1000 });
              }}
              sx={{ p: "2px", color: "text.secondary" }}
              title="Copy Name"
            >
              <ContentCopyIcon sx={{ fontSize: "16px" }} />
            </IconButton>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mt: 0.5 }}>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              User ID: {formData._id}
            </Typography>
            <IconButton
              size="small"
              onClick={() => {
                navigator.clipboard.writeText(formData._id);
                toast.success("User ID copied to clipboard!", { position: "top-center", autoClose: 1000 });
              }}
              sx={{ p: "2px", color: "text.secondary" }}
              title="Copy User ID"
            >
              <ContentCopyIcon sx={{ fontSize: "14px" }} />
            </IconButton>
          </Box>
        </Box>

        {data?.isOwner && !readOnly && (
          <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <Button
              variant="outlined"
              onClick={handleMenuClick}
              endIcon={<KeyboardArrowDownIcon />}
              sx={{ textTransform: "none", fontWeight: 600, minWidth: "180px", justifyContent: "space-between" }}
            >
              {partnerId ? getPartnerName(partnerId) : "Select Partner"}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              PaperProps={{
                sx: { maxHeight: "250px", width: "240px" }
              }}
            >
              {partnersData.map((item: any) => (
                <MenuItem key={item._id} onClick={() => handlePartnerSelect(item._id)}>
                  {item.contactPersonName} ({item.partnerCode})
                </MenuItem>
              ))}
            </Menu>
            <Button
              variant="contained"
              onClick={handleAsignPartner}
              disabled={!partnerId}
              sx={{ textTransform: "none", fontWeight: 600, px: 3 }}
            >
              Assign Partner
            </Button>
          </Box>
        )}
      </Box>

      <Divider />

      {/* User Information Grid */}
      <Grid container spacing={3}>
        {fields.map((field: any, index) => {
          let displayValue = field.customValue !== undefined ? field.customValue : formData[field.name];
          if (field.isDate && displayValue) {
            displayValue = moment(displayValue).format("DD-MM-YYYY hh:mm A");
          } else if (field.isBoolean) {
            displayValue = displayValue ? "Yes" : "No";
          }
          if (!displayValue) {
            displayValue = field.defaultValue || "N/A";
          }

          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  p: "16px",
                  borderRadius: "12px",
                  border: "1px solid",
                  borderColor: "divider",
                  backgroundColor: theme.palette.mode === "light" ? "#f8fafc" : "#1e293b50",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    backgroundColor: theme.palette.mode === "light" ? "#f0f7ff" : "#1e3a8a33",
                    color: "primary.main",
                  }}
                >
                  {field.icon}
                </Box>
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600, textTransform: "uppercase", tracking: "0.5px" }}>
                    {field.label}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <Typography sx={{ fontWeight: 600, color: "text.primary", fontSize: "15px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flexGrow: 1 }}>
                      {displayValue}
                    </Typography>
                    {field.isCopyable && displayValue && displayValue !== "N/A" && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          navigator.clipboard.writeText(displayValue);
                          toast.success(`${field.label} copied to clipboard!`, { position: "top-center", autoClose: 1000 });
                        }}
                        sx={{ p: "2px", color: "text.secondary", flexShrink: 0 }}
                        title={`Copy ${field.label}`}
                      >
                        <ContentCopyIcon sx={{ fontSize: "14px" }} />
                      </IconButton>
                    )}
                  </Box>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>

      <Divider sx={{ my: 1 }} />

      {/* Connector details list */}
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: "16px", color: "text.primary" }}>
          Connector & License Details
        </Typography>

        {connData?.length > 0 ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            {connData.map((connArr: any, index: number) => {
              const connectorsList = Array.isArray(connArr) ? connArr : (connArr?.connectors || []);
              return (
                <Box
                  key={index}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                    gap: "16px",
                    p: "8px 0"
                  }}
                >
                  {connectorsList.map((obj: any, oIdx: number) => {
                    if (!obj) return null;
                    return (
                      <Card
                        key={obj.machineId || oIdx}
                        variant="outlined"
                        sx={{
                          borderRadius: "12px",
                          borderColor: "divider",
                          boxShadow: "none",
                          "&:hover": {
                            borderColor: "primary.main",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
                          },
                          transition: "all 0.2s ease"
                        }}
                      >
                        <CardContent sx={{ display: "flex", flexDirection: "column", gap: "16px", p: "20px !important" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <Box>
                              <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 700 }}>
                                CONNECTOR MACHINE ID
                              </Typography>
                              <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <Typography sx={{ fontWeight: 750, color: "text.primary", fontSize: "14px" }}>
                                  {obj.machineId && typeof obj.machineId === "string" ? obj.machineId.slice(-12).toUpperCase() : "N/A"}
                                </Typography>
                                {obj.machineId && (
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      navigator.clipboard.writeText(obj.machineId);
                                      toast.success("Machine ID copied to clipboard!", { position: "top-center", autoClose: 1000 });
                                    }}
                                    sx={{ p: "2px", color: "text.secondary" }}
                                    title="Copy Machine ID"
                                  >
                                    <ContentCopyIcon sx={{ fontSize: "14px" }} />
                                  </IconButton>
                                )}
                              </Box>
                            </Box>
                        <Chip
                          label={obj.config?.isTallyConnected ? "Tally Connected" : "Disconnected"}
                          size="small"
                          color={obj.config?.isTallyConnected ? "success" : "default"}
                          sx={{ fontWeight: 600, fontSize: "11px" }}
                        />
                      </Box>

                      <Divider />

                      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <LocalPoliceIcon sx={{ fontSize: 18, color: "error.main" }} />
                          <Typography variant="body2" sx={{ color: "text.primary", display: "flex", alignItems: "center", gap: "6px" }}>
                            From License:{" "}
                            {obj?.companies?.[0]?.companyName && typeof obj.companies[0].companyName === "string" ? (
                              <>
                                <Box component="span" sx={{ fontWeight: 700, color: "primary.main" }}>
                                  {obj.companies[0].companyName.includes("_")
                                    ? obj.companies[0].companyName.split("_").reverse()[1] || obj.companies[0].companyName
                                    : obj.companies[0].companyName}
                                </Box>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    const compName = obj.companies[0].companyName;
                                    const licenseNo = compName.includes("_")
                                      ? compName.split("_").reverse()[1] || compName
                                      : compName;
                                    navigator.clipboard.writeText(licenseNo);
                                    toast.success("License number copied to clipboard!", { position: "top-center", autoClose: 1000 });
                                  }}
                                  sx={{ p: "2px", color: "text.secondary" }}
                                  title="Copy License Number"
                                >
                                  <ContentCopyIcon sx={{ fontSize: "12px" }} />
                                </IconButton>
                              </>
                            ) : (
                              <Box component="span" sx={{ fontWeight: 700, color: "text.secondary" }}>
                                No company license
                              </Box>
                            )}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                          <StoreIcon sx={{ fontSize: 18, color: "primary.main", mt: "2px" }} />
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="body2" sx={{ color: "text.primary" }}>
                              Companies:
                            </Typography>
                            <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }}>
                              {obj?.companies?.length > 0
                                ? obj.companies
                                    .map((company: any) =>
                                      company?.companyName && typeof company.companyName === "string"
                                        ? company.companyName.split("_")[0]
                                        : "Unnamed Company"
                                    )
                                    .join(", ")
                                : "None"}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      {obj.config && (
                        <Box sx={{ mt: 1, p: "10px", borderRadius: "8px", backgroundColor: theme.palette.mode === "light" ? "#f8fafc" : "#1e293b50", border: "1px solid", borderColor: "divider" }}>
                          <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 700, display: "block", mb: 1 }}>
                            CONFIGURATION DETAILS
                          </Typography>
                          <Grid container spacing={1}>
                            {Object.keys(obj.config).map((key: any) => (
                              <Grid item xs={6} key={key}>
                                <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }}>
                                  {key}
                                </Typography>
                                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "text.primary" }}>
                                  {obj.config[key].toString()}
                                </Typography>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}
                    </CardContent>
                  </Card>
                );
              })}
            </Box>
          );
        })}
      </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 4,
              borderRadius: "12px",
              border: "1px dashed",
              borderColor: "divider",
              backgroundColor: theme.palette.mode === "light" ? "#f8fafc" : "#1e293b30",
            }}
          >
            <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 500 }}>
              No connector or license details found for this user.
            </Typography>
          </Box>
        )}
      </Box>

      <ToastContainer style={{ width: "auto" }} />
    </Box>
  );
}
